import React from 'react';
import { Form, FloatingLabel, Button } from 'react-bootstrap';
import { BsTrash } from 'react-icons/bs';

interface BuyLinkFormProps {
    ticket_group_code: string;
    items: any[];
    tickets: any[];
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onChange: (ticketIndex: number, field: string, value: any) => void;
    onButtonChange: (ticketIndex: number, buttonIndex: number, field: string, value: string) => void;
    onAddNewTicket: () => void;
    heading: string[];
}

export default function BuyLinkForm({
    ticket_group_code,
    items,
    tickets,
    onTicketGroupCodeChange,
    onChange,
    onButtonChange,
    onAddNewTicket,
    heading,
}: BuyLinkFormProps) {
    return (
        <>
            <div className="mb-4">
                <h2 className="GraphikSemibold text-[18px] text-[#1f2328] mb-3">Content</h2>

                <Form.Group className="mb-3" controlId="formCategory">
                    <Form.Label className="text-sm mb-2">Ticket Group Code</Form.Label>
                    <Form.Select required aria-label="Select Category" className="bg-gray-200 mb-2" value={ticket_group_code} onChange={onTicketGroupCodeChange}>
                        <option value="">Select Ticket Group Code</option>
                        {items.map((item) => (
                            <option key={item.ticket_id} value={item.ticket_group_code}>
                                {item.ticket_group_code}
                            </option>
                        ))}
                    </Form.Select>
                </Form.Group>

                <Form.Group className="mb-3" controlId="formCategory">
                    <Button variant="danger" onClick={onAddNewTicket}>
                        Add New Ticket Selling
                    </Button>   
                </Form.Group>

                {tickets.map((ticket, ticketIndex) => (
                    <div key={ticket.id || ticketIndex} className="mb-5 border-t pt-2">
                        <div className="flex flex-row justify-between items-center mb-2">
                            <h2 className="GraphikSemibold text-[16px] text-[#1f2328]">
                                {heading[ticketIndex] || `Ticket Selling ${ticketIndex + 1}`}
                            </h2>

                            <Button variant="secondary">
                                Remove
                            </Button>
                        </div>

                        <div className="mb-3">
                            <Form.Label className="text-sm mb-2">Title</Form.Label>
                            <Form.Control
                                type="text"
                                value={ticket.title || ''}
                                onChange={(e) => onChange(ticketIndex, 'title', e.target.value)}
                                className="bg-gray-200 me-2"
                            />
                        </div>

                        <Form.Group className="mb-3">
                            <Form.Label className="text-sm mb-2">Button and Links</Form.Label>
                            {(ticket.link_buttons || []).map((btn: any, buttonIndex: number) => (
                                <div key={buttonIndex} className="d-flex align-items-center mb-3">
                                    <Form.Control
                                        type="text"
                                        placeholder="Button Name"
                                        value={btn.button_name || ''}
                                        onChange={(e) =>
                                            onButtonChange(ticketIndex, buttonIndex, 'button_name', e.target.value)
                                        }
                                        className="bg-gray-200 me-2"
                                    />

                                    <Form.Control
                                        type="text"
                                        placeholder="Url"
                                        value={btn.url || ''}
                                        onChange={(e) =>
                                            onButtonChange(ticketIndex, buttonIndex, 'url', e.target.value)
                                        }
                                        className="bg-gray-200 me-2"
                                    />

                                    <Button
                                        variant="secondary"
                                        onClick={() => {
                                            const updated = [...tickets];
                                            updated[ticketIndex].link_buttons.splice(buttonIndex, 1);
                                            onChange(ticketIndex, 'link_buttons', updated[ticketIndex].link_buttons);
                                        }}
                                    >
                                        <BsTrash />
                                    </Button>
                                </div>
                            ))}

                            <div>
                                <Button
                                    variant="danger"
                                    onClick={() => {
                                        const updated = [...tickets];
                                        if (!updated[ticketIndex].link_buttons) {
                                            updated[ticketIndex].link_buttons = [];
                                        }
                                        updated[ticketIndex].link_buttons.push({ button_name: '', url: '' });
                                        onChange(ticketIndex, 'link_buttons', updated[ticketIndex].link_buttons);
                                    }}
                                >
                                    Add More
                                </Button>
                            </div>
                        </Form.Group>

                        <div className="mb-4">
                            <div className="d-flex align-items-start mb-3 gap-2">
                                <h2 className="GraphikSemibold text-[16px] text-[#1f2328]">
                                    Ticketing Schedule
                                </h2>
                            </div>

                            <div className="grid grid-cols-2 gap-2 mb-3">
                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">Start Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ticket.start_date?.slice(0, 10) || ''}
                                        onChange={(e) => onChange(ticketIndex, 'start_date', e.target.value)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">Start Time</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={ticket.start_time || ''}
                                        onChange={(e) => onChange(ticketIndex, 'start_time', e.target.value)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>
                            </div>

                            <div className="grid grid-cols-2 gap-2 mb-3">
                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">End Date</Form.Label>
                                    <Form.Control
                                        type="date"
                                        value={ticket.end_date?.slice(0, 10) || ''}
                                        onChange={(e) => onChange(ticketIndex, 'end_date', e.target.value)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>

                                <Form.Group>
                                    <Form.Label className="text-sm mb-2">End Time</Form.Label>
                                    <Form.Control
                                        type="time"
                                        value={ticket.end_time || ''}
                                        onChange={(e) => onChange(ticketIndex, 'end_time', e.target.value)}
                                        className="bg-gray-200"
                                    />
                                </Form.Group>
                            </div>

                            <div className="mb-3">
                                <Form.Label className="text-sm mb-2">Description</Form.Label>
                                <Form.Control
                                    type="text"
                                    value={ticket.description || ''}
                                    onChange={(e) => onChange(ticketIndex, 'description', e.target.value)}
                                    className="bg-gray-200"
                                />
                            </div>

                            <div className="mt-3">
                                <Form.Check
                                    type="checkbox"
                                    label="For Logged-in Users Only"
                                    checked={!!ticket.is_exclusive}
                                    onChange={(e) => onChange(ticketIndex, 'is_exclusive', e.target.checked ? 1 : 0)}
                                />
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </>
    );
}